import FieldObject from './FieldObject.js'
import formats from '../../../api/formats'
import store from '../../../store'
import client from '../../client'
import people from '../../people'
import favorite from '../../favorite'

export default class CompanyField extends FieldObject {
  getCode (model) {
    return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null
  }
  setCode (model, newCode, onChange) {
    client.getBriefCompanies([newCode]).then((refs) => {
      if (refs && refs.length > 0) {
        let newObject = refs[0]
        this.setValue(model, newObject.ref, newObject, onChange)
      } else {
        this.setValue(model, null, null, onChange)
      }
      this.cxt.updateItems(model)
    })
  }
  getDescription (model) {
    let result = model[this.name + 'DESCRIPTION']
    if (this.ref === 'SELF') {
      result = result + ' (Наша компания)'
    }
    return result
  }
  setValue (model, newCode, newObject, onChange) {
    // console.log('setValue', this.name, newCode, newObject)
    if (!this.equalCode(model, newCode)) {
      onChange && onChange(model, this.name, newCode)
      model[this.name + '_CODE'] = newCode ? newCode + '' : null
    }
    model[this.name] = newCode && newObject ? newObject.inn : null
    model[this.name + 'DESCRIPTION'] = newCode && newObject ? newObject.caption : null
  }
  fillRef (model, data, onChange) {
    if (formats.isRefCode(data)) {
      var refs = this.cxt.refMap.get(this.name)
      if (refs) {
        refs.forEach(r => {
          let fobj = this.cxt.fieldObjects.get(r)
          if (fobj.type === 'HOLDERS') {
            client.getBriefCompanies([data]).then((refs) => {
              if (refs && refs.length > 0) {
                fobj.setCode(model, refs[0].ref, onChange)
              }
            })
          }
          if (fobj.type === 'CONTACT') {
            people.getContactsByCompany(data).then((contacts) => {
              let items = people.sortContactsByCompany(contacts)
              if (items && items.length > 0) {
                fobj.setCode(model, items[0].id, onChange)
              }
            })
          }
          if (fobj.type === 'COMPANY_BANK') {
            favorite.getCompanyBanks(data).then((data) => {
              let items = data.sort((b, a) => formats.compareString(a.name, b.name))
              if (items && items.length > 0) {
                fobj.setCode(model, items[0].id, onChange)
              }
            })
          }
        })
        this.cxt.updateItems(model)
      }
    }
  }
  open (model, onChange) {
    let url = this.cxt.context.getClientUrl(this.getCode(model))
    store.dispatch('openLocation', url)
  }
  select (model, onChange) {
    console.log('CompanyField:select', model)
    const setItem = (values) => {
      // console.log('setItem', values)
      if (Array.isArray(values) && values.length > 0) {
        let newObject = values[0]
        this.setValue(model, newObject.ref, newObject, onChange)
        this.cxt.updateItems(model)
      }
    }
    const getQuery = () => this.getCode(model) ? this.getCode(model) : ''
    client.selectRef(this.cxt.context, setItem, getQuery, true, true)
  }

}



// WEBPACK FOOTER //
// ./src/components/assist/fields/CompanyField.js